export const ApprovalsHistoryLogPermissions = {
  GetApprovalLog: {
    permissionsId: 'a337a49e-163a-49bd-7963-08dcaf947ea8',
    permissionsName: 'Get Approval Log',
    description: null,
    componentsId: null,
    components: null,
  },
};
